
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetomahabaleshawarpanchgani() {



    const cardData =
    {
        keyword: 'Pune to Mahabaleshwar Panchgani Innova Crysta Cabs',
        heading: 'Meghana Cab : Pune to Mahabaleshwar Panchgani Innova Crysta Cabs',
        headingDescription: 'Meghana Cab offers Pune to Mahabaleshwar & Panchgani Innova Crysta Cabs, designed for travelers seeking a comfortable, scenic, and luxurious hill‑station excursion. Our Innova Crysta vehicles feature plush leather interiors, spacious seating, and generous luggage space—ideal for small groups, families, or friends on a day trip or overnight stay. Whether you’re heading to Mahabaleshwar’s lush valleys or Panchgani’s panoramic viewpoints, enjoy a smooth and stylish ride via the picturesque Western Ghats. Our seasoned chauffeurs know the best hill roads and stopping points for photos, strawberry picking, or local cuisine breaks.',


        top: 'Top Places to Visit in Mahabaleshwar with Meghana Cab',

"topPlaces": [
  {
    "title": "Venna Lake",
    "description": "One of the most popular tourist spots in Mahabaleshwar, Venna Lake is a scenic man-made lake surrounded by dense forest and hills. Built in 1842, it offers activities such as paddle boating, rowing, and horse riding along its banks. The lakefront is lined with snack stalls serving local treats like corn, strawberries, and mulberries, making it a favorite destination for families and couples alike. Sunsets here are particularly magical, with reflections dancing across the still waters."
  },
  {
    "title": "Arthur’s Seat",
    "description": "Often referred to as the ‘Queen of all Points’, Arthur’s Seat offers a breathtaking view of the deep Savitri Valley on one side and the lush Brahma-Arayana Valley on the other. Named after British officer Sir Arthur Malet, this viewpoint is famous for its floating object illusion and panoramic cliffside setting. The trail to Arthur’s Seat passes other viewpoints like Echo Point, Tiger Spring, and Hunter Point, making it a complete scenic circuit."
  },
  {
    "title": "Pratapgad Fort",
    "description": "Located around 21 km from Mahabaleshwar, Pratapgad Fort is a historically significant site where Chhatrapati Shivaji Maharaj defeated Afzal Khan in 1659. The fort offers stunning views of the surrounding valleys, lush greenery, and mountain ridges. Visitors can explore the Bhavani Mata Temple, the watchtowers, and the statue of Shivaji Maharaj. Guides are available to narrate tales of Maratha bravery and tactical warfare. It's a must-visit for history buffs and trekkers alike."
  },
  {
    "title": "Mapro Garden",
    "description": "Located en route to Mahabaleshwar from Panchgani, Mapro Garden is a beautifully landscaped campus known for its strawberries, fruit-based products, and delicious food. Visitors can try Mapro’s signature strawberry cream, sandwiches, wood-fired pizzas, and refreshing fruit crushes. The garden also houses a chocolate factory, a small amphitheater, and retail outlets selling jams, syrups, and preserves. It's a family-friendly destination that blends nature, food, and fun."
  },
  {
    "title": "Lingmala Waterfall",
    "description": "Situated between Mahabaleshwar and Panchgani, Lingmala Waterfall is a mesmerizing sight, especially during the monsoon season. The main waterfall plunges from a height of around 600 feet, offering a breathtaking view of white water crashing into a rocky gorge. There's also a smaller, more accessible waterfall nearby for those who want to get closer. Surrounded by forested trails, this is a great spot for photography, short hikes, and enjoying the monsoon mist."
  },
  {
    "title": "Elephant’s Head Point",
    "description": "This unique rock formation resembles the head and trunk of an elephant, making it one of the most photographed spots in Mahabaleshwar. Located near Lodwick Point, it offers panoramic views of the Sahyadri mountains and the deep valleys below. The spot is surrounded by tranquility and cool mountain breezes, ideal for quiet contemplation and landscape photography. Monsoon and early winter are the best seasons to witness its dramatic beauty."
  },
  {
    "title": "Wilson Point (Sunrise Point)",
    "description": "The highest point in Mahabaleshwar, Wilson Point sits at 1,439 meters above sea level and is the best place to catch a spectacular sunrise. It offers a 360-degree panoramic view of Mahabaleshwar’s valleys, forests, and plateaus. With three designated towers and ample space, it attracts early morning walkers, photographers, and nature lovers. Unlike other points, Wilson Point is open and accessible year-round without any major trek."
  },
  {
    "title": "Panchganga Temple",
    "description": "Panchganga Temple is a 13th-century temple believed to be the origin of five rivers—Krishna, Venna, Savitri, Koyna, and Gayatri. Located within the old Mahabaleshwar temple complex, it features ancient architecture, stone-carved idols, and a sacred Gaumukh (cow-shaped spout) from which the river water flows. It's a significant pilgrimage site for devotees and a peaceful place for visitors to soak in the spiritual ambiance."
  },
  {
    "title": "Mahabaleshwar Temple",
    "description": "Dedicated to Lord Shiva, Mahabaleshwar Temple is one of the oldest temples in the region, built in the Hemadpanthi style. It houses the swayambhu (self-originated) lingam, a sacred relic believed to be around 500 years old. Located near Panchganga Temple, the site draws pilgrims throughout the year and remains one of the town’s most spiritually significant landmarks."
  },
  {
    "title": "Kate’s Point & Needle Hole Point",
    "description": "Kate’s Point is a stunning viewpoint that offers panoramic views of the Krishna Valley, Dhom Dam, and the surrounding mountain ranges. Nearby, Needle Hole Point (or Elephant Point) features a naturally formed rock arch that looks like a needle’s eye. These points are easily accessible by road and are known for cool breezes, wide vistas, and their popularity among photographers and nature lovers."
  }
],

"services": [
  {
    "name": "Pune to Mahabaleshwar Panchgani Innova Crysta Cab Booking",
    "description": "Book your Innova Crysta cab for the scenic Pune to Mahabaleshwar Panchgani route. Enjoy a comfortable, spacious ride with our well-maintained vehicles and professional chauffeurs, perfect for solo travelers, families, and groups looking to explore these beautiful hill stations."
  },
  {
    "name": "One Way Innova Crysta Pune to Mahabaleshwar Panchgani",
    "description": "Plan a hassle-free one-way trip from Pune to Mahabaleshwar Panchgani with our Innova Crysta taxi. Our reliable service ensures punctual pickup and a smooth journey through picturesque landscapes, ideal for quick getaways or business travel."
  },
  {
    "name": "Round Trip Innova Crysta Pune Mahabaleshwar Panchgani",
    "description": "Opt for our round trip Innova Crysta service from Pune to Mahabaleshwar and Panchgani for a seamless travel experience. Enjoy the convenience of flexible scheduling, comfortable seating, and a dedicated chauffeur to take care of your entire journey."
  },
  {
    "name": "AC Innova Crysta Taxi Pune to Mahabaleshwar Panchgani",
    "description": "Beat the heat and travel in style with our air-conditioned Innova Crysta taxis from Pune to Mahabaleshwar Panchgani. Experience plush interiors, climate control, and a smooth ride that keeps you refreshed throughout your trip."
  },
  {
    "name": "Chauffeur Driven Innova Crysta Pune to Mahabaleshwar Panchgani",
    "description": "Sit back and relax with our chauffeur-driven Innova Crysta service on the Pune to Mahabaleshwar Panchgani route. Our trained drivers ensure safe driving, timely pickups, and courteous service for a stress-free travel experience."
  },
  {
    "name": "Family Innova Crysta Trip Pune to Mahabaleshwar Panchgani",
    "description": "Make your family trip to Mahabaleshwar and Panchgani memorable and comfortable with our spacious Innova Crysta cabs. With ample legroom and luggage space, our vehicles are perfect for group travel, sightseeing, and leisure."
  },
  {
    "name": "Budget Innova Crysta Cab Pune to Mahabaleshwar Panchgani",
    "description": "Travel economically without sacrificing comfort with our budget-friendly Innova Crysta cab services from Pune to Mahabaleshwar Panchgani. Transparent pricing and flexible packages make it easy to plan your getaway within your budget."
  },
  {
    "name": "Online Innova Crysta Booking Pune to Mahabaleshwar Panchgani",
    "description": "Easily book your Innova Crysta cab online for travel between Pune and Mahabaleshwar Panchgani. Enjoy quick confirmations, secure payments, and customizable trip options to suit your schedule and preferences."
  }
],
"tableData": [
  ["Pune to Mahabaleshwar Panchgani Innova Crysta Cab Booking", "One Way Innova Crysta Pune to Mahabaleshwar Panchgani"],
  ["Round Trip Innova Crysta Pune Mahabaleshwar Panchgani", "AC Innova Crysta Taxi Pune to Mahabaleshwar Panchgani"],
  ["Chauffeur Driven Innova Crysta Pune to Mahabaleshwar Panchgani", "Family Innova Crysta Trip Pune to Mahabaleshwar Panchgani"],
  ["Budget Innova Crysta Cab Pune to Mahabaleshwar Panchgani", "Online Innova Crysta Booking Pune to Mahabaleshwar Panchgani"]
],



"whychoose": [
    {
        "WhyChooseheading": "Luxury Innova Crysta Cabs from Pune to Mahabaleshwar & Panchgani",
        "WhyChoosedescription": "Travel in comfort and style to the picturesque hill stations of Mahabaleshwar and Panchgani with our premium Innova Crysta cab service. Perfect for family vacations, group trips, and weekend escapes, our service ensures a safe and memorable journey through the Western Ghats."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Travel Experience",
        "WhyChoosedescription": "The Innova Crysta offers seating for 6–7 passengers with plush, reclining seats, rear AC vents, and a smooth suspension system. Whether it’s a short break or an extended stay, your ride will be comfortable and enjoyable, even on curvy hill roads."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Ghat Route Expertise",
        "WhyChoosedescription": "Our professional drivers are highly experienced in navigating the winding roads of the Sahyadri hills. They prioritize safety, drive with care through the ghats, and can recommend scenic viewpoints and local eateries along the way."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "All Innova Crysta vehicles are regularly cleaned, sanitized, and maintained to the highest standards. You can expect a hygienic and comfortable ride, ideal for family and senior-friendly travel."
    },
    {
        "WhyChooseheading": "Flexible Booking Options and Custom Itineraries",
        "WhyChoosedescription": "Choose from one-way, round-trip, or multi-day packages as per your schedule. Customize your pickup and drop locations, sightseeing stops like Mapro Garden or Table Land, and travel times to suit your itinerary."
    },
    {
        "WhyChooseheading": "Transparent and Affordable Pricing",
        "WhyChoosedescription": "Our cab fares are all-inclusive with no hidden charges. The fare covers fuel, tolls, driver allowance, and taxes—ensuring clear pricing for a worry-free experience."
    },
    {
        "WhyChooseheading": "Perfect for Family Holidays, Group Outings, and Honeymoon Trips",
        "WhyChoosedescription": "Whether you're planning a romantic getaway, a family vacation, or a group tour, our Innova Crysta cabs provide the space and comfort needed for a premium hill station experience."
    },
    {
        "WhyChooseheading": "24/7 Booking Assistance and Customer Support",
        "WhyChoosedescription": "Book your Pune to Mahabaleshwar Panchgani cab anytime through our website or helpline. Our team is available round the clock to help with bookings, reschedules, or itinerary planning."
    }
]



















    }

const faqData = [
    {
        question: "How can I book an Innova Crysta cab from Pune to Mahabaleshwar and Panchgani?",
        answer: "You can easily book by calling Meghana Cab at +91 9075462128 or through our website for a hassle-free experience."
    },
    {
        question: "What is the distance and travel time from Pune to Mahabaleshwar and Panchgani?",
        answer: "Mahabaleshwar is about 120 km and Panchgani around 100 km from Pune, with travel time roughly 3 to 4 hours depending on traffic."
    },
    {
        question: "Is Innova Crysta comfortable for hill station travel?",
        answer: "Yes, Innova Crysta offers a smooth and comfortable ride, suitable for the winding roads to hill stations."
    },
    {
        question: "Can I book a one-way or round trip for Mahabaleshwar and Panchgani?",
        answer: "Yes, both one-way and round-trip bookings are available according to your travel plan."
    },
    {
        question: "How many passengers can an Innova Crysta accommodate?",
        answer: "The Innova Crysta comfortably seats 6 to 7 passengers along with luggage."
    },
    {
        question: "Are the cabs sanitized before every trip?",
        answer: "Yes, all vehicles are thoroughly cleaned and sanitized before each journey to ensure your safety."
    },
    {
        question: "Do the drivers have experience driving in hill stations?",
        answer: "Absolutely. Our drivers are experienced in navigating the hilly terrain for a safe and comfortable trip."
    },
    {
        question: "What is included in the fare from Pune to Mahabaleshwar and Panchgani?",
        answer: "The fare includes driver charges, fuel, and tolls. Additional waiting or parking charges may apply."
    },
    {
        question: "Is the Innova Crysta cab service available 24/7?",
        answer: "Yes, Meghana Cab offers round-the-clock service for this route."
    },
    {
        question: "What payment methods are accepted?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash payments."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Ajay Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“The Innova Crysta was perfect for our trip to Mahabaleshwar and Panchgani. Spacious and comfortable with a professional driver.”',
    },
    {
        name: 'Ms. Priya Deshpande',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Great service from Meghana Cab. The Innova Crysta handled the hill roads well and made our trip very enjoyable.”',
    },
];



















































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];









const puneToMahabaleshwarPanchganiSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune to Mahabaleshwar Panchgani Innova Crysta Cab Service",
  "description": "Book AC Innova Crysta cabs for Pune to Mahabaleshwar Panchgani travel. Ideal for one way, round trips, family trips, chauffeur driven rides, and budget-friendly taxi service.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": "Outstation Taxi Service",
  "areaServed": [
    {
      "@type": "City",
      "name": "Pune"
    },
    {
      "@type": "City",
      "name": "Mahabaleshwar"
    },
    {
      "@type": "City",
      "name": "Panchgani"
    }
  ],
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-mahabaleshwar-panchgani-innova-crysta-cab"
  }
};





    return (
        <div>

<Helmet>
  <title>Pune to Mahabaleshwar Panchgani Innova Crysta Cab | Book Now</title>
  <meta
    name="description"
    content="Book AC Innova Crysta cabs for Pune to Mahabaleshwar Panchgani travel. Chauffeur driven, budget-friendly, and family trips available."
  />
  <meta
    name="keywords"
    content="Pune to Mahabaleshwar Panchgani Innova Crysta Cab Booking, One Way Innova Crysta Pune to Mahabaleshwar Panchgani, Round Trip Innova Crysta Pune Mahabaleshwar Panchgani, AC Innova Crysta Taxi Pune to Mahabaleshwar Panchgani, Chauffeur Driven Innova Crysta Pune to Mahabaleshwar Panchgani, Family Innova Crysta Trip Pune to Mahabaleshwar Panchgani, Budget Innova Crysta Cab Pune to Mahabaleshwar Panchgani, Online Innova Crysta Booking Pune to Mahabaleshwar Panchgani"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToMahabaleshwarPanchganiSchema)}
  </script>
</Helmet>



            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/33.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetomahabaleshawarpanchgani;